import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '@core/notification.service';

import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private readonly notificationService: NotificationService,
    private readonly translateService: TranslateService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(response => {
        if (!response) {
          this.showSeverError();
        }
      }),
      catchError((error: HttpResponse<HttpErrorResponse>) => {
        const willHandle = !SILENT_URL.test(request.url);

        if (willHandle && !EXCLUDED_STATUS.has(error.status)) {
          this.showSeverError(error);
        }
        console.log('Error: ');
        console.log(request);
        console.log(error);
        return this.errorHandler(error);
      })
    );
  }

  showSeverError(error: HttpEvent<unknown> = null): void {
    if (navigator.onLine) {
      this.notificationService.showSomethingWentWrong(error);
    } else {
      this.notificationService.show(
        this.translateService.instant('Network-Disconnected'),
        this.translateService.instant('Unknown-Error')
      );
    }
  }

  // Customize the default error handler here if needed
  private errorHandler(
    response: HttpEvent<unknown>
  ): Observable<HttpEvent<unknown>> {
    throw response;
  }
}

const EXCLUDED_STATUS = new Set([200, 400, 401, 403, 404, 0]);

/**
 * Requests whose failure the caller handles on its own, so the generic
 * "something went wrong" notification would only confuse the user.
 * accounts/email/check-activation fails open into the normal register call.
 */
const SILENT_URL =
  /(wp-json\/wp\/v2\/media|accounts\/email\/check-activation)/i;
